import { isModuleEnabled } from '../../config/moduleConfig';
import schedulingModule from '../scheduling/module';

const optionalModules = [
  schedulingModule
];

export const getEnabledOptionalModules = () => (
  optionalModules.filter((module) => isModuleEnabled(module.id))
);

export const getOptionalModuleRoutes = () => (
  getEnabledOptionalModules().flatMap((module) => module.routes || [])
);

export const getOptionalModuleNavigationItems = () => (
  getEnabledOptionalModules()
    .map((module) => module.navigation)
    .filter(Boolean)
);

export const getOptionalLandingModules = () => (
  getEnabledOptionalModules().map((module) => ({
    id: module.id,
    title: module.title,
    description: module.description,
    icon: module.icon,
    path: module.path,
    available: true,
    color: module.color
  }))
);

export const getOptionalModuleAdminPermissions = () => (
  getEnabledOptionalModules().flatMap((module) => module.adminPermissions || [])
);
